import { UserFilter } from '../../../../shared/types/user';

export const initialValues: UserFilter = {
    document: '',
    name: '',
    surname: '',
    username: '',
    type: '',
};
